import { Dispatch } from "redux";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { setOrganizationUserDetails } from "@redux/actions/organization-user-details-actions";
import { updateAxnAdminUserRequest } from "@requests/axnadmin-core";

export const updateOrganizationUserDetailsReduxRequest = (dispatch: Dispatch) => async (axnAdminUser: AxnAdminUser) => {
    const { data, error, body } = await updateAxnAdminUserRequest(axnAdminUser);
    if (data?.transferObject) {
        dispatch(setOrganizationUserDetails({
            ...data.transferObject,
            permissions: axnAdminUser.permissions
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.updateOrganizationUserDetails.success.title,
            resources.requests.updateOrganizationUserDetails.success.message
        );
        return data.transferObject;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateOrganizationUserDetails.error.title,
            resources.requests.updateOrganizationUserDetails.error.message,
            null,
            null,
            body
        );
    }

    return null;
};